import {
  TrendingUp,
  TrendingDown,
  Wrench,
  Repeat,
  ListChecks,
  AlertTriangle,
  Clock,
  CheckCircle,
  Users,
  Timer,
  Activity,
  DollarSign,
} from 'lucide-react';

/**
 * Report type configuration for the Reporting Details tab dropdown.
 * Accepts `t` from react-i18next to translate labels.
 */
export const getReportTypes = (t) => [
  { key: 'createdVsResolved', title: t('reporting.created_vs_resolved.title', 'Created vs. Completed'), icon: TrendingUp },
  { key: 'workOrdersByType', title: t('reporting.work_orders_by_type.title', 'Work Orders by Type'), icon: Wrench },
  { key: 'repeatingReport', title: t('reporting.repeating_report.title', 'Repeating vs Non-Repeating'), icon: Repeat },
  { key: 'statusReport', title: t('shared.status', 'Status Distribution'), icon: ListChecks },
  { key: 'priorityReport', title: t('shared.priority', 'Priority Distribution'), icon: AlertTriangle },
  { key: 'timeToComplete', title: t('reporting.time_to_complete.title', 'Time to Complete'), icon: Clock },
  { key: 'onTimeOverdue', title: t('reporting.on_time_overdue.title', 'On Time vs. Overdue'), icon: CheckCircle },
  { key: 'completedByUser', title: t('reporting.completed_by_user.title', 'Completed by User'), icon: Users },
  { key: 'statusDurationReport', title: t('reporting.status_duration.title', 'Status Duration'), icon: Timer },
  { key: 'totalDowntime', title: t('reporting.total_downtime.title', 'Total Downtime'), icon: TrendingDown },
  { key: 'mtbf', title: t('reporting.mtbf.title', 'Mean Time Between Failures'), icon: Activity },
  { key: 'workOrderCost', title: t('reporting.cost.spend.title', 'Work order spend'), icon: DollarSign },
];

/**
 * Grouping dimension options (coming soon).
 * Accepts `t` from react-i18next to translate labels.
 */
export const getGroupingDimensions = (t) => [
  { key: 'team', label: t('shared.team', 'Team') },
  { key: 'user', label: t('shared.user', 'User') },
  { key: 'asset', label: t('shared.asset', 'Asset') },
  { key: 'location', label: t('shared.location', 'Location') },
  { key: 'category', label: t('shared.category', 'Category') },
  { key: 'assetType', label: t('shared.asset_category', 'Asset Category') },
  { key: 'vendor', label: t('shared.vendor', 'Vendor') },
];

